<template>
  <div>
    <van-nav-bar v-if="name == 'ActiveInfo' ||
      name == 'Register' ||
      name == 'Sign' ||
      name == 'Scancode' ||
      name == 'Myactive' ||
      name == 'UserInfo' ||
      name == 'Protocol' ||
      name == 'Policy'
      " :title="title" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight" :fixed="true"
      z-index="999">
      <!-- <div slot="left"></div> -->
    </van-nav-bar>
  </div>
</template>
<script>
// import { Toast } from "vant";
export default {
  data() {
    return {
      title: null,
      name: null,
    };
  },
  methods: {
    onClickLeft() {
      if (this.name == 'ActiveInfo' || this.name == 'Scancode') {
        this.$router.push("/");
      }
      else {
        this.$router.go(-1);
      }
      // Toast("返回");
    },
    onClickRight() {
      // Toast("按钮");
    },
  },
  created() {
    // console.log(this.$route);
    this.title = this.$route.meta;
    this.name = this.$route.name;
  },
};
</script>
<style lang="scss" scoped>
.van-hairline--bottom::after {
  border-bottom-width: 10px;
  border-color: #f8f8f8;
}
</style>